"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.$mainProvision = exports.mainProvisionToLines = void 0;
const factory_1 = require("../factory");
const line_1 = require("../../../node/cst/line");
const util_1 = require("../util");
const std_1 = require("../../../law/std");
const std = __importStar(require("../../../law/std"));
const _paragraphItem_1 = __importStar(require("./$paragraphItem"));
const util_2 = require("../../../util");
const _article_1 = __importStar(require("./$article"));
const _articleGroup_1 = __importStar(require("./$articleGroup"));
const toCSTSettings_1 = __importDefault(require("../toCSTSettings"));
const el_1 = require("../../../node/el");
/**
 * The renderer for {@link std.MainProvision}. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$mainProvision.spec.ts) for examples.
 */
const mainProvisionToLines = (mainProvision, indentTexts) => {
    const lines = [];
    const paragraphs = mainProvision.children.filter(std_1.isParagraph);
    const isSingleAnonymParagraph = ((paragraphs.length === 1) &&
        paragraphs.every(p => (p.children.filter(std_1.isParagraphItemTitle).every(el => el.text() === "") &&
            (p.children.filter(c => std.isParagraphSentence(c) && c.text().length > 0).length > 0))));
    for (const child of mainProvision.children) {
        if ((0, std_1.isParagraphItem)(child)) {
            if (isSingleAnonymParagraph) {
                lines.push(...(0, _paragraphItem_1.paragraphItemToLines)(child, indentTexts, { noControl: true }));
            }
            else {
                lines.push(...(0, _paragraphItem_1.paragraphItemToLines)(child, indentTexts, { defaultTag: "Paragraph" }));
            }
            lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
        }
        else if ((0, std_1.isArticle)(child)) {
            lines.push(...(0, _article_1.articleToLines)(child, indentTexts));
            lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
        }
        else if ((0, std_1.isArticleGroup)(child)) {
            lines.push(...(0, _articleGroup_1.articleGroupToLines)(child, indentTexts));
            lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
        }
        else {
            (0, util_2.assertNever)(child);
        }
    }
    return lines;
};
exports.mainProvisionToLines = mainProvisionToLines;
const $mainProvisionChildren = factory_1.factory
    .withName("mainProvisionChildren")
    .sequence(s => s
    .and(r => r
    .choice(c => c
    .or(r => r
    .oneOrMore(r => r
    .sequence(s => s
    .and(r => r
    .choice(c => c
    .or(() => _article_1.default)
    .or(() => _articleGroup_1.default)))
    .andOmit(r => r.zeroOrMore(() => util_1.$blankLine)))))
    .or(r => r
    .oneOrMore(r => r
    .sequence(s => s
    .and(r => r
    .choice(c => c
    .or(() => (0, _paragraphItem_1.default)("Paragraph"))))
    .andOmit(r => r.zeroOrMore(() => util_1.$blankLine)))))
    .or(r => r
    .sequence(s => s
    .and(r => r
    .oneOrMore(r => r
    .sequence(s => s
    .and(r => r
    .choice(c => c
    .or(() => _paragraphItem_1.$noControlAnonymParagraph)))
    .andOmit(r => r.zeroOrMore(() => util_1.$blankLine)))), "anonymParagraphs")
    .action(({ anonymParagraphs }) => {
    for (const [i, { value: paragraph }] of anonymParagraphs.entries()) {
        paragraph.attr.Num = (i + 1).toString();
    }
    return anonymParagraphs;
})))), "children")
    .action(({ children }) => {
    return {
        value: children.map(c => c.value).flat(),
        errors: children.map(c => c.errors).flat(),
    };
}));
/**
 * The parser rule for {@link std.MainProvision}. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$mainProvision.spec.ts) for examples.
 */
exports.$mainProvision = factory_1.factory
    .withName("mainProvision")
    .sequence(s => s
    .and(() => $mainProvisionChildren, "children")
    .action(({ children }) => {
    // for (let i = 0; i < children.value.length; i++) {
    //     children.value[i].attr.Num = `${i + 1}`;
    // }
    const mainProvision = (0, std_1.newStdEL)("MainProvision", {}, children.value, (0, el_1.rangeOfELs)(children.value));
    return {
        value: mainProvision,
        errors: [
            ...children.errors,
            // ...(error instanceof ErrorMessage ? [error] : []),
        ],
    };
}));
exports.default = exports.$mainProvision;
//# sourceMappingURL=$mainProvision.js.map